// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"8962e581","163":"fa425b87","393":"b94322db","548":"29140dcc","887":"e95f71e2"}[chunkId] + ".chunk.js";
};